import { render } from "./AppNavbarAppsMenu.vue?vue&type=template&id=4b52a8b0"
import script from "./AppNavbarAppsMenu.vue?vue&type=script&lang=js"
export * from "./AppNavbarAppsMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__